<template>
  <div
    v-if="
      selectedCompanyId && selected_company && !selected_company.is_screening_pricing_enterprise
    "
  >
    <!-- <v-list-tile class="default-class highlight" @click="addOnsDialog = true">
      <v-list-tile-action>
        <v-icon>add</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t("manage_addons.title") }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile> -->
    <v-btn @click="addOnsDialog = true" small elevation=""  color="primary" outline><v-icon>add</v-icon>{{ $t("buy_addons.title") }}</v-btn>

    <v-layout v-if="addOnsDialog" row justify-center>
      <v-dialog
        :value="addOnsDialog"
        @input="reset()"
        persistent
        scrollable
        max-width="50vw"
      >
        <v-card>
          <v-card-title class="px-4">
            <div class="title">{{ $t("manage_addons.title") }}</div>
            <v-spacer></v-spacer>
            <v-btn
              class="mx-0 px-0"
              small
              dark
              icon
              color="grey"
              @click="reset()"
            >
              <v-icon small>$vuetify.icons.rms_close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="max-height: 80vh">
            <v-stepper class="elevation-0" v-model="addon_step">
              <v-stepper-header flat class="elevation-0 px-0">
                <v-stepper-step
                  step="1"
                  :complete="addon_step > 1"
                  editable
                  class="px-3"
                  >{{ $t("addons.title") }}</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  step="2"
                  :complete="addon_step > 2"
                  :editable="addOns && addOns.length ? true : false"
                  class="px-3"
                >
                  {{ $t("screener.upgrade_step.second_step.title") }}
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-items class="pa-3">
                <v-stepper-content step="1" class="pa-0">
                  <div>
                    <v-layout class="pb-2">
                      <span class="subheading">
                        <b>{{
                          "Add Ons " + $t("screener.seats_planner.title")
                        }}</b>
                      </span>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card class="border-grey-all" flat>
                          <v-card-text>
                            <div class="py-2">
                              <div class="subheading pb-2">
                                <b>{{ $t("addons_to_buy.title") }}</b>
                              </div>
                              <p class="greyDarken3--text">
                                {{ $t("addons_to_buy.subtitle") }}
                              </p>
                            </div>

                            <v-layout row wrap class="mb-4">
                              <v-flex xs12>
                                <v-card
                                  v-for="addOn in availableAddOns"
                                  :key="addOn.id"
                                  class="border-grey-all mb-3"
                                  flat
                                >
                                  <v-card-text primary-title>
                                    <v-layout row wrap>
                                      <v-flex xs12 md1>
                                        <div class="headline">
                                          {{
                                            DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL
                                          }}{{ addOn.amount }}
                                        </div>
                                      </v-flex>
                                      <v-flex xs12 md7>
                                        <h3 class="headline">
                                          {{ addOn.title }}
                                        </h3>
                                        <div>{{ addOn.description }}</div>
                                      </v-flex>
                                      <v-flex xs12 md4 class="text-md-right">
                                        <v-btn
                                          v-if="
                                            getAddonIndex(addOn.id) < 0 &&
                                            !addOn.quantity
                                          "
                                          outline
                                          @click="
                                            addOn.quantity += 1;
                                            setAddon(addOn);
                                          "
                                          color="primary"
                                          class="mr-0"
                                          >{{ $t("rms.button.add") }}
                                        </v-btn>

                                        <integer-plusminus
                                          v-else
                                          :key="addOn.id + '1'"
                                          :min="0"
                                          :max="100"
                                          :step="1"
                                          v-model="addOn.quantity"
                                          class="d-inline-flex mt-2"
                                          @input="setAddon(addOn)"
                                        >
                                        </integer-plusminus>
                                      </v-flex>
                                    </v-layout>
                                  </v-card-text>
                                </v-card>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap class="pb-3">
                              <v-flex xs12 md12>
                                <v-layout row wrap>
                                  <v-flex xs12 md6>
                                    <div>
                                      <div class="display-2">
                                        {{ totalAddons }}
                                      </div>
                                      <div class="subheading greyDarken3--text">
                                        {{ $t("addons.title") }}
                                      </div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs12 md6 class="text-md-right">
                                    <div>
                                      <div class="display-2">
                                        {{
                                          DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL
                                        }}{{ totalAmount }}
                                      </div>
                                      <div class="subheading greyDarken3--text">
                                        {{ $t("payable_amount.title") }}
                                      </div>
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-divider class="mb-3"></v-divider>

                            <v-layout row wrap>
                              <v-flex xs12 class="text-md-right">
                                <v-btn
                                  color="grey"
                                  class="mt-0 ml-0"
                                  large
                                  dark
                                  flat
                                  @click="reset()"
                                  >{{ $t("rms.button.cancel") }}
                                </v-btn>
                                <v-btn
                                  large
                                  class="mt-0 mr-0"
                                  color="secondary"
                                  :disabled="!totalAddons"
                                  @click="goToStep(2)"
                                  >{{ $t("rms.button.continue") }}
                                </v-btn>
                              </v-flex>
                            </v-layout>

                            <template v-if="selected_company.addons">
                              <div class="subheading pb-2">
                                <b>{{ $t("already_purchased.title") }}</b>
                                <v-icon class="px-1" color="success" small
                                  >$vuetify.icons.rms_rule_is_enabled</v-icon
                                >
                              </div>
                              <v-data-table
                                dense
                                :headers="headers"
                                :items="Object.values(selected_company.addons)"
                                hide-actions
                                class="border-grey-all mb-3"
                              >
                                <template v-slot:items="props">
                                  <tr>
                                    <td class="body-1">
                                      {{ __getAddonNameById(props.item.id) }}
                                    </td>
                                    <td class="body-1">
                                      {{ props.item.used }}&nbsp;/&nbsp;{{
                                        props.item.quantity
                                      }}
                                    </td>
                                    <td class="body-1">
                                      <b
                                        >{{
                                          DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL
                                        }}{{ props.item.amount }}</b
                                      >
                                    </td>
                                    <td>
                                      {{
                                        moment
                                          .utc(props.item.created_at)
                                          .local()
                                          .format("Do MMM YYYY, hh:mm")
                                      }}
                                    </td>
                                  </tr>
                                </template>
                                <template slot="footer">
                                  <tr>
                                    <td>
                                      <b>{{ $t("budget_spent.title") }}</b>
                                    </td>
                                    <td>
                                      <b>
                                        {{ addOnsTotal.used }}&nbsp;/&nbsp;
                                        {{ addOnsTotal.quantity }}</b
                                      >
                                    </td>
                                    <td>
                                      <b>
                                        {{
                                          DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL +
                                          addOnsTotal.amount
                                        }}
                                      </b>
                                    </td>
                                    <td>-</td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </div>
                  <Faqs class="mt-3" :faqs="DEFINES.ADDONS_FAQS"></Faqs>
                </v-stepper-content>

                <v-stepper-content step="2" class="pa-0">
                  <template
                    v-if="
                      selected_company.card_brand &&
                      selected_company.card_last_four
                    "
                  >
                    <v-radio-group
                      hide-details
                      v-model="use_existing_payment_method"
                      row
                      class="mb-5 mt-0"
                      color="primary"
                    >
                      <RadioInput
                        :value="true"
                        :label="$t('screener.use_existing_payment_mthd.title')"
                      ></RadioInput>
                      <RadioInput
                        :value="false"
                        :label="$t('screener.add_payment_mthd.title')"
                      ></RadioInput>
                    </v-radio-group>
                    <div v-if="use_existing_payment_method">
                      <ExistingPaymentMethod></ExistingPaymentMethod>
                    </div>
                    <div v-else>
                      <PaymentForm
                        class="mt-3"
                        :payment_method.sync="payment_method"
                        ref="paymentDetailForm"
                      ></PaymentForm>
                      <div class="greyDarken3--text">
                        <div class="pt-1">
                          <i>{{
                            $t("screener.upgrade.payment_method.instruction.1")
                          }}</i>
                        </div>
                        <div class="pt-1">
                          <i>{{
                            $t("screener.upgrade.payment_method.instruction.2")
                          }}</i>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <PaymentForm
                      class="mt-3"
                      :payment_method.sync="payment_method"
                      ref="paymentDetailForm"
                    ></PaymentForm>
                  </template>
                  <v-layout class="mt-5">
                    <v-btn
                      class="mx-0"
                      dark
                      color="grey"
                      @click="addon_step = 1"
                      ><v-icon small class="px-1"
                        >$vuetify.icons.screener_back</v-icon
                      >{{ $t("screener.btn.back") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="ml-0" dark color="grey" @click="reset()">{{
                      $t("rms.button.cancel")
                    }}</v-btn>
                    <v-btn
                      class="mr-0"
                      dark
                      color="secondary"
                      @click="payNow()"
                      >{{
                        $t("screener.btn.pay_now") +
                        " - " +
                        DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL +
                        totalAmount
                      }}</v-btn
                    >
                  </v-layout>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import DEFINES from "@/defines";
import rules from "@/validation";
import i18n from "@/i18n";
import { mapState, mapGetters } from "vuex";
import ScreenerPlans from "@/components/screener/Plans";
import PaymentForm from "@/components/PaymentForm";
import RadioInput from "@/components/RadioInput";
import ExistingPaymentMethod from "@/components/ExistingPaymentMethod";
import Faqs from "@/components/FAQs";
import { IntegerPlusminus } from "vue-integer-plusminus";

export default {
  name: "ScreeningAddOns",
  props: {},
  data() {
    return {
      rules,
      availableAddOns: DEFINES.SCREENING_ADD_ONS,
      addOnsDialog: false,
      addon_step: 1,
      addOns: [],
      payment_method: null,
      use_existing_payment_method: this.isPaymentMethodExists(),
      ipm_value: 1,
      totalAddons: 0,
      totalAmount: 0,
      headers: [
        {
          text: this.$t("addon.table_header.title"),
          align: "left",
          sortable: false,
          value: "title",
        },
        {
          text: this.$t("addon.table_header.quantity"),
          align: "left",
          sortable: false,
          value: "used",
        },
        {
          text: this.$t("addon.table_header.amount"),
          align: "left",
          sortable: false,
          value: "amount",
        },
        {
          text: this.$t("addon.table_header.created_at"),
          align: "left",
          sortable: false,
          value: "created_at",
        },
      ],
      payment_intent_id: null,
    };
  },
  components: {
    ScreenerPlans,
    PaymentForm,
    RadioInput,
    ExistingPaymentMethod,
    Faqs,
    IntegerPlusminus,
  },
  computed: {
    ...mapGetters("company", {
      selected_company: "getSelectedCompany",
      selectedCompanyId: "getSelected",
    }),

    addOnsTotal: function () {
      let addOnsTotal = {
        used: 0,
        quantity: 0,
        amount: 0,
      };
      if (this.selected_company && this.selected_company.addons) {
        let addons = Object.values(this.selected_company.addons);
        addons.forEach((addOn) => {
          addOnsTotal.used += addOn.used;
          addOnsTotal.quantity += addOn.quantity;
          addOnsTotal.amount += addOn.amount;
        });
      }
      return addOnsTotal;
    },
  },
  watch: {
    addOns: {
      handler: function () {
        this.calculateBudget();
      },
      deep: true,
    },
  },
  methods: {
    getAddonIndex(addOnId) {
      return this.addOns.findIndex((addOn) => addOn.id === addOnId);
    },

    setAddon(addOnObj) {
      let itemIndex = this.getAddonIndex(addOnObj.id);

      if (addOnObj.quantity == 0 && itemIndex >= 0) {
        this.addOns.splice(itemIndex, 1);
      } else {
        if (itemIndex < 0) {
          let data = {};
          data.id = addOnObj.id;
          data.quantity = addOnObj.quantity;
          data.amount = addOnObj.amount;
          this.addOns.push(data);
        } else {
          this.addOns[itemIndex].quantity = addOnObj.quantity;
        }
      }
    },

    goToStep(step = 1) {
      this.addon_step = step;
    },

    reset() {
      // Reset everything
      this.use_existing_payment_method = true;
      // Steppers first step will not mount payment form
      if (this.$refs.paymentDetailForm) {
        this.$refs.paymentDetailForm.reset();
      }
      this.addOnsDialog = false;
      this.addOns = [];
      this.goToStep();
      this.availableAddOns.forEach((addOn) => {
        addOn.quantity = 0;
      });
    },

    calculateBudget() {
      let vue = this;
      this.totalAddons = 0;
      this.totalAmount = 0;
      if (this.addOns.length) {
        this.addOns.forEach((addOn) => {
          vue.totalAddons += addOn.quantity;
          vue.totalAmount += vue.calculateAmount(addOn.quantity, addOn.amount);
        });
      }
    },

    calculateAmount(quantity, price) {
      if (!quantity || !price) {
        return 0;
      }
      return quantity * price;
    },

    async authenticationComplete(event) {
      if (
        event.data != '3DS-authentication-complete' ||
        !this.payment_intent_id
      ) {
        return;
      }

      // mark the purchase paid
      try {
        // Preparing payload
        var payload = {};

        payload.addons = this.addOns;
        payload.payment_method = this.payment_method;
        payload.use_existing_payment_method = this.use_existing_payment_method;
        payload.payment_intent_id = this.payment_intent_id;

        let response = await this.$store.dispatch(
          'company/markAddonPurchased',
          payload
        );
        this.reset();
        await this.$store.dispatch("app/showMessage", {
          message: this.$t("message.addon.purchase.success"),
          color: "success",
        });
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      } finally {
        this.payment_intent_id = null;
      }
    },

    async payNow() {
      try {
        // Preparing payload
        var payload = {};

        payload.addons = this.addOns;
        payload.payment_method = this.payment_method;
        payload.use_existing_payment_method = this.use_existing_payment_method;

        // Go to pay for add ons
        var response = await this.$store.dispatch("company/buyAddons", payload);
        if (response.intent) {
          var stripe = Stripe(DEFINES.STRIPE_KEY);
          // Let Stripe handle any required 3D Secure challenge in its own managed
          // modal (resolves only once authentication completes). The payment method
          // is already attached to the PaymentIntent server-side.
          let res = await stripe.confirmCardPayment(
            response.intent.client_secret,
            {
              payment_method: response.intent.payment_method,
            }
          );

          if (res.error) {
            throw res.error;
          }

          this.payment_intent_id = res.paymentIntent.id;

          if (res.paymentIntent.status != 'succeeded') {
            throw new Error(
              (res.paymentIntent.last_payment_error &&
                res.paymentIntent.last_payment_error.message) ||
                res.paymentIntent.status
            );
          }

          // Payment (and any 3D Secure authentication) complete -> mark purchased.
          this.authenticationComplete({ data: '3DS-authentication-complete' });
        } else if(response.company) {
          this.reset();
          await this.$store.dispatch("app/showMessage", {
            message: this.$t("message.addon.purchase.success"),
            color: "success",
          });
        }
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    isPaymentMethodExists() {
      return this.$store.state.company.company &&
        this.$store.state.company.company.card_brand &&
        this.$store.state.company.company.card_last_four
        ? true
        : false;
    },
    __getAddonNameById(addonId) {
      let aon = this.DEFINES.SCREENING_ADD_ONS.find(
        (addon) => addon.id === addonId
      );
      return aon.title;
    },
  },
};
</script>
